import type { BgpCommunities } from '@ipfabric/utils/settings/types/types';
import { BgpDataTransferForm } from 'components/BgpSettings/dataTransfer/BgpDataTransferForm';
import type { FC } from 'react';

type Props = {
  existingBgpEntries: BgpCommunities[];
  onClose: () => void;
  onImportSuccess: (data: BgpCommunities[], replaceEntries: boolean) => void;
};

export const BgpDataTransferManager: FC<Props> = ({
  existingBgpEntries,
  onClose,
  onImportSuccess,
}) => {
  return (
    <BgpDataTransferForm
      existingBgpEntries={existingBgpEntries}
      onClose={onClose}
      onImportSuccess={onImportSuccess}
    />
  );
};
